export function handleMediaChange(cb) {

    try {
        const mediaQuery = window.matchMedia('(max-width: 767px)');
        mediaQuery.addEventListener('change', (e) => cb(e.matches ? 'mobile' : 'desktop'));
        cb(mediaQuery.matches ? 'mobile' : 'desktop');

    } catch (error) {
        console.error(error);
    }
}

export function isMobile() {
    const mediaQuery = window.matchMedia('(max-width: 767px)');
    return mediaQuery.matches;
}

export function isDesktop() {
    const mediaQuery = window.matchMedia('(min-width: 768px)');
    return mediaQuery.matches;
}